import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ kicker, title, sub, center = false }) => (
  <div className={center ? "text-center" : ""}>
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-electric" data-testid="section-kicker">
        {kicker}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-slate-50 mt-4 leading-[1.02]">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`text-base text-slate-400 mt-4 max-w-xl ${center ? "mx-auto" : ""}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
